import React from "react";
import "./Location.css";

const Location = () => {
  return (
    <div className="location-container">
      <div className="location-info">
        <h2>Our Location</h2>
        <p>
          Visit Thompson Square Pharmacy for your prescriptions, consultations,
          and more. We are conveniently located to serve you with easy access
          and ample parking. Below, you can find our address and operating
          hours.
        </p>
      </div>
      <div className="map-container">
        {/* Replace with your preferred map embed or component */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.2568817099514!2d-79.85342692345068!3d43.51783566117487!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b6f634519bb2d%3A0x1e76c4d84a679871!2sThompson%20Square%20Pharmacy!5e0!3m2!1sen!2sca!4v1730798389722!5m2!1sen!2sca"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="details-container">
        <div className="address">
          <h3>Address</h3>
          <p>9137 Derry Rd W #1, Milton, ON L9T 7Z1, Canada</p>
        </div>
        <div className="hours">
          <h3>Business Hours</h3>
          <p>Monday: 10:00 AM - 6:00 PM</p>
          <p>Tuesday to Thursday: 10:00 AM - 6:30 PM</p>
          <p>Friday: 10:00 AM - 6:00 PM</p>
          <p>Saturday: 10:00 AM - 2:00 PM</p>
          <p>Sunday: Closed</p>
        </div>
        <div className="address">
          <h3>Contact</h3>
          <p>Phone: &nbsp;&nbsp;+1 905-749-9990</p>
          <p>Fax: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+1 905-749-9001</p>
          <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;thompsonsquarepharmacy@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default Location;
